import { gql } from '@apollo/client'

export default gql`
  fragment EmployeeDisplayTinyInfo on EmployeeDisplayTinyInfo {
    id
    firstName
    lastName
    avatarUrl
  }
`
